export const videoRoutesDefinitions = {
  home: {
    path: 'home',
    name: 'videoHome'
  },
  homeNoVideos: {
    path: 'no-videos',
    name: 'homeNoVideos'
  },
  homeInitFailed: {
    path: 'init-failed',
    name: 'homeInitFailed'
  },
  createProject: {
    path: 'home/create-project',
    name: 'createProject'
  },
  contentEditor: {
    path: 'content-editor/:id',
    name: 'contentEditor'
  },
  hiwiReview: {
    path: 'hiwi-review',
    name: 'videoHiwiReview'
  },
  slides: {
    path: 'slides',
    name: 'videoSlides'
  },
  results: {
    path: 'results',
    name: 'videoResults'
  },
  resultsV2: {
    path: 'v2/results',
    name: 'videoResultsV2'
  },
  homeV2: {
    path: 'v2/home',
    name: 'videoHomeV2'
  },
  createProjectV2: {
    path: 'v2/home/create-project',
    name: 'createProjectV2'
  },
  contentEditorV2: {
    path: 'v2/home/content-editor/:id',
    name: 'contentEditorV2'
  },
  contentEditorCustomWithSlidesV2: {
    path: 'v2/home/content-editor-custom-with-slides/:id',
    name: 'contentEditorCustomWithSlidesV2'
  },
  hiwiReviewV2: {
    path: 'v2/hiwi-review',
    name: 'videoHiwiReviewV2'
  },
  uploadToMyCampus: {
    path: 'v2/upload-to-mycampus/:id',
    name: 'uploadToMyCampus'
  }
};
